import cloneDeep from 'lodash/cloneDeep'

export const pickupInformation = {
    longitude: null,
    latitude: null,
    postCode: null,
    country: null,
    city: null,
    street: null,
    houseNumber: null,
    fullAddress: null,
    contactPhone: '',
    contactCompany: '',
    contactEmail: '',
    contactFirstName: '',
    contactLastName: '',
    pickupInstructions: null,
}

export function isPIfilled(pickupInfo) {
    return !!(
        pickupInfo?.longitude ||
        pickupInfo?.latitude ||
        pickupInfo?.postCode ||
        pickupInfo?.country ||
        pickupInfo?.city ||
        pickupInfo?.street ||
        pickupInfo?.houseNumber ||
        pickupInfo?.fullAddress ||
        pickupInfo?.contactPhone ||
        pickupInfo?.contactCompany ||
        pickupInfo?.contactEmail ||
        pickupInfo?.contactFirstName ||
        pickupInfo?.contactLastName ||
        pickupInfo?.pickupInstructions
    )
}

export function getPiClone() {
    return cloneDeep(pickupInformation)
}

// The pickup address is the restaurant's one address (tasks#211): on save the admin copies it into
// the restaurant location / coordinates (search, delivery zones, travel time) and into the click &
// collect address, which are not edited on their own any more.
const ADDRESS_KEYS = [
    'longitude',
    'latitude',
    'postCode',
    'country',
    'city',
    'street',
    'houseNumber',
    'fullAddress',
]

const phoneDigits = (phone) => String(phone || '').replace(/\D/g, '')

// a courier phone equal to the restaurant phone is shown as "not overridden"
export function isRestaurantPhone(phone, restaurantPhone) {
    const digits = phoneDigits(phone)
    return digits !== '' && digits === phoneDigits(restaurantPhone)
}

export function applyPickupAddress(entity) {
    const pickup = entity.pickupInformation
    if (!pickup?.fullAddress) return

    // couriers get the restaurant phone unless the tab sets a phone of their own; core-api sends
    // its fixed support address instead of the contact e-mail
    pickup.contactPhone = pickup.contactPhone || entity.phone
    pickup.contactEmail = pickup.contactEmail || 'support@ordit.co.uk'

    entity.location = pickup.fullAddress
    entity.latitude = pickup.latitude
    entity.longitude = pickup.longitude
    if (pickup.city) entity.city = pickup.city

    // a click & collect row is only written for a restaurant that has (or turns on) one
    const collect = entity.personalPickupInformation
    if (
        collect &&
        (collect['@id'] ||
            collect.personalCollectionEnabled ||
            Number(collect.minimumOrderValue) > 0 ||
            collect.photoOfThePlace)
    ) {
        ADDRESS_KEYS.forEach((key) => (collect[key] = pickup[key]))
        collect.contactPhone = entity.phone
    }
}
